"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_TYPE = void 0;
var EVENT_TYPE;
(function (EVENT_TYPE) {
    EVENT_TYPE[EVENT_TYPE["ONLINE"] = 0] = "ONLINE";
    EVENT_TYPE[EVENT_TYPE["OFFLINE"] = 1] = "OFFLINE";
})(EVENT_TYPE || (exports.EVENT_TYPE = EVENT_TYPE = {}));
